"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _MetricGroupItem = _interopRequireDefault(require("./MetricGroupItem"));

var _index = require("./index");

var _excluded = ["children"],
    _excluded2 = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint quote-props:0 */
var LABELS = {
  "longest-streak": {
    label: "Longest Streak",
    unit: "seconds"
  },
  "median-streak": {
    label: "Median Streak",
    unit: "seconds"
  },
  "average-streak": {
    label: "Average Streak",
    unit: "seconds"
  },
  "longest-silence-streak": {
    label: "Longest Silence Streak",
    unit: "seconds"
  },
  "intra-call-change-in-pitch": {
    label: "Change in Pitch",
    unit: "score"
  },
  "intra-call-change-in-relative-voice-volume-energy": {
    label: "Change in Volume",
    unit: "score"
  },
  "intra-call-change-in-sentiment": {
    label: "Change in Sentiment",
    unit: "score"
  },
  "intra-call-change-in-talk-rate": {
    label: "Change in Talk Rate",
    unit: "score"
  },
  "voice-unpredictability": {
    label: "Voice Unpredictability",
    unit: "score"
  },
  vocabulary: {
    label: "Vocabulary",
    unit: "score"
  },
  "overtalk-incidents": {
    label: "Overtalk Incidents",
    unit: "incidents"
  },
  "overtalk-ratio": {
    label: "Overtalk Ratio",
    unit: "ratio"
  },
  "relative-voice-volume-energy": {
    label: "Volume/Energy",
    unit: "ratio"
  },
  "silence-incidents": {
    label: "Silence Incidents",
    unit: "incidents"
  },
  "silence-ratio": {
    label: "Silence Ratio",
    unit: "ratio"
  },
  "talk-rate": {
    label: "Talk Rate",
    unit: "score"
  },
  "talk-ratio": {
    label: "Talk Ratio",
    unit: "ratio"
  },
  "intra-agent-to-caller-talk-rate-ratio": {
    label: "Talk Rate Ratio",
    unit: "ratio"
  },
  "voice-dynamism-std-dev-score": {
    label: "Voice Dynamism",
    unit: "score"
  },
  overtalk: {
    label: "Overtalk",
    unit: "incidents"
  },
  "call-sentiment": {
    label: "Overall Sentiment",
    unit: "score"
  },
  sentiment: {
    label: "Overall Sentiment",
    unit: "score"
  },
  "start-sentiment": {
    label: "Start Sentiment",
    unit: "score"
  },
  "end-sentiment": {
    label: "End Sentiment",
    unit: "score"
  },
  "talk-style-tone-and-volume": {
    label: "Tone",
    unit: "score"
  },
  "talk-time-and-rate": {
    label: "Talk Time",
    unit: "score"
  },
  "messaging-response-time": {
    label: "Messaging Response Time",
    unit: "score"
  },
  "first-response-time": {
    label: "First Response Time",
    unit: "seconds"
  },
  "first-time-in-queue": {
    label: "First Time In Queue",
    unit: "seconds"
  },
  "active-duration": {
    label: "Active Duration",
    unit: "seconds"
  },
  "active-agent-duration": {
    label: "Active  Agent Duration",
    unit: "seconds"
  },
  "post-assign-first-response-time": {
    label: "Agent First Response Time (After Assigned)",
    unit: "seconds"
  },
  "time-to-assign": {
    label: "Time to Assign",
    unit: "seconds"
  },
  "first-time-in-bot": {
    label: "First Time In Bot",
    unit: "seconds"
  },
  "total-response-time": {
    label: "Total Response Time",
    unit: "seconds"
  },
  "avg-response-time": {
    label: "Average Response Time",
    unit: "seconds"
  },
  "max-response-time": {
    label: "Max Response Time",
    unit: "seconds"
  },
  "median-response-time": {
    label: "Median Response Time",
    unit: "seconds"
  },
  "total-wait-time": {
    label: "Total Wait Time",
    unit: "seconds"
  },
  "number-of-transitions-different-agents": {
    label: "Transfer Count",
    unit: ""
  },
  "message-count": {
    label: "Message Count",
    unit: ""
  },
  "responses-count": {
    label: "Response Count",
    unit: ""
  },
  mcs: {
    label: "MCS",
    unit: ""
  },
  "call-mcs": {
    label: "MCS",
    unit: ""
  }
};
var ORDER = [// "overtalk" Section
"overtalk-incidents", "overtalk-ratio", // "sentiment" Section
"intra-call-change-in-sentiment", "sentiment", "call-sentiment", "start-sentiment", "end-sentiment", // "talk-time-and-rate" Section
"longest-streak", "median-streak", "average-streak", "longest-silence-streak", "intra-call-change-in-talk-rate", "silence-incidents", "silence-ratio", "talk-rate", "talk-ratio", "intra-agent-to-caller-talk-rate-ratio", // "MCS" Section
"mcs", // "talk-style-tone-and-volume" Section
"intra-call-change-in-pitch", "intra-call-change-in-relative-voice-volume-energy", "relative-voice-volume-energy", "voice-dynamism-std-dev-score", "vocabulary", "voice-unpredictability", // "messaging-response-time" Section
"first-time-in-queue", "first-time-in-bot", "time-to-assign", "post-assign-first-response-time", "first-response-time", "active-agent-duration", "active-duration", "total-response-time", "avg-response-time", "max-response-time", "median-response-time", "total-wait-time", "number-of-transitions-different-agents", "message-count", "responses-count"];

var StyledRow = function StyledRow(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "metrics-group-row"
  }, rest), children);
};

var StyledBar = function StyledBar(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "metrics-group-bar"
  }, rest), children);
};
/* eslint no-prototype-builtins:0 */


var MetricGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MetricGroup, _React$Component);

  function MetricGroup(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.data = {};
    _this.sortedData = {};
    _this.groupUnits = _this.parseMetricGroupUnits(props.groupUnits);
    return _this;
  }

  var _proto = MetricGroup.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var metricValues = this.props.metricValues;
    this.sortedData = this.sortData(metricValues);
  };

  _proto.getLabel = function getLabel(val) {
    return (0, _lodash.get)(LABELS, [val, "label"], "");
  };

  _proto.getUnits = function getUnits(val) {
    return (0, _lodash.get)(this.groupUnits, [val, "unit"], (0, _lodash.get)(LABELS, [val, "unit"], ""));
  };

  _proto.parseMetricGroupUnits = function parseMetricGroupUnits(groupUnits) {
    var _this2 = this;

    var unitsResponse = {};
    groupUnits.forEach(function (val) {
      val.metrics.forEach(function (metric) {
        var isCallMetric = metric.metricName.startsWith("call-");
        var metricUnitKey = isCallMetric ? _this2.parseMetricUnit(metric.metricName.substring(metric.metricName.indexOf("-") + 1)) : _this2.parseMetricUnit(metric.metricName);
        unitsResponse[metricUnitKey] = {
          unit: metric.metricUnit !== "units" ? metric.metricUnit : ""
        };
      });
    });
    return unitsResponse;
  } // Gets the speaker associated with the specific metricName
  // ie. agent-first-response-time returns "Agent"
  // ie. bot-max-response-time returns "Bot"
  ;

  _proto.parseSpeaker = function parseSpeaker(metricName) {
    var firstDashIndex = metricName.indexOf("-");
    var firstWordSubString = metricName.substr(0, firstDashIndex) || "";
    return _index.speakers[firstWordSubString.toUpperCase()] || _index.speakers.OVERALL;
  } // Gets the metric name after remove speaker ('agent' or 'caller') from metricName
  ;

  _proto.parseMetricLabel = function parseMetricLabel(metricName) {
    var nameSubstr = metricName;
    var firstDashIndex = metricName.indexOf("-");
    var firstWordSubString = metricName.substr(0, firstDashIndex) || "";

    if (_index.speakers[firstWordSubString.toUpperCase()]) {
      nameSubstr = metricName.substr(firstDashIndex + 1);
    }

    return Object.keys(LABELS).find(function (key) {
      return nameSubstr === key;
    });
  };

  _proto.parseMetricUnit = function parseMetricUnit(metricName) {
    var nameSubstr = metricName;
    var firstDashIndex = metricName.indexOf("-");
    var firstWordSubString = metricName.substr(0, firstDashIndex) || "";

    if (_index.speakers[firstWordSubString.toUpperCase()]) {
      nameSubstr = metricName.substr(firstDashIndex + 1);
    }

    return nameSubstr;
  };

  _proto.applySpeakerValues = function applySpeakerValues(speaker, metricLabel, metricValue) {
    var speakerValues = {};
    speakerValues[speaker.toLowerCase()] = {
      label: this.getLabel(metricLabel),
      units: this.getUnits(metricLabel) === "milliseconds" ? "seconds" : this.getUnits(metricLabel),
      val: this.getUnits(metricLabel) === "milliseconds" ? metricValue / 1000 : metricValue,
      type: "aType"
    };
    return speakerValues;
  }
  /* eslint class-methods-use-this:0 */
  ;

  _proto.sortData = function sortData(metricValues) {
    var _this3 = this;

    return metricValues.reduce(function (accValues, _ref3) {
      var _formattedData;

      var metricName = _ref3.metricName,
          metricValue = _ref3.metricValue;

      var speakerName = _this3.parseSpeaker(metricName);

      var isCallMetric = metricName.startsWith("call-");
      var metricLabel = isCallMetric ? _this3.parseMetricLabel(metricName.substring(metricName.indexOf("-") + 1)) : _this3.parseMetricLabel(metricName);

      var speakerValues = _this3.applySpeakerValues(speakerName, metricLabel, metricValue);

      var formattedData = (_formattedData = {}, _formattedData[metricLabel] = {
        speaker: speakerValues,
        label: _this3.getLabel(metricLabel),
        units: _this3.getUnits(metricLabel) === "milliseconds" ? "seconds" : _this3.getUnits(metricLabel)
      }, _formattedData);
      (0, _lodash.merge)(accValues, formattedData);
      return accValues;
    }, {});
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props = this.props,
        metricGroupName = _this$props.metricGroupName,
        filteredSpeakers = _this$props.filteredSpeakers;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(StyledRow, null, /*#__PURE__*/_react["default"].createElement("div", null, this.getLabel(metricGroupName)), filteredSpeakers.map(function (speaker) {
      return /*#__PURE__*/_react["default"].createElement(StyledBar, null);
    })), ORDER.map(function (key) {
      if (_this4.sortedData.hasOwnProperty(key) && _this4.sortedData[key]) {
        return /*#__PURE__*/_react["default"].createElement(_MetricGroupItem["default"], {
          key: key,
          data: _this4.sortedData[key],
          filteredSpeakers: filteredSpeakers
        });
      } else {
        return null;
      }
    }));
  };

  return MetricGroup;
}(_react["default"].Component);

var _default = MetricGroup;
exports["default"] = _default;
MetricGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  metricGroupName: _propTypes["default"].string.isRequired,
  metricValues: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    metricName: _propTypes["default"].string,
    metricValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })).isRequired
} : {};